import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { DEFAULT_LOCALE } from '@di-tokens';
import { DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT } from '@models';

@Pipe({
  name: 'dateTime',
  standalone: true,
})
export class DateTimePipe implements PipeTransform {
  private locale = inject(DEFAULT_LOCALE);
  private datePipe = new DatePipe(this.locale);
  transform(
    value: Date | string | number,
    dateFormat = DEFAULT_DATE_FORMAT,
    timeFormat = DEFAULT_TIME_FORMAT,
    timezone?: string,
    locale?: string,
  ): string {
    return `${this.datePipe.transform(value, dateFormat, timezone, locale)} by ${this.datePipe.transform(value, timeFormat, timezone, locale)}`;
  }
}
